import React from 'react';
import Styled from 'styled-components';
import * as color from '../colors';
import logo from '../../assets/images/logo-alt.svg';
import Button from './button';

const Aside = Styled.aside`
display: block;
background-color: ${color.primary};
max-width: 30rem;
padding: 2rem;
height: 100vh;
display: grid;
grid-template-rows: max-content 1fr;
place-content:center;
`;

const AsideAccount = Styled.div`
display: flex;
align-items: flex-start;
justify-content: center;
padding: 2rem;
text-transform: uppercase;
color:${color.primaryAlt};
font-size: 2.5rem;

`;

const AsideHeader = Styled.header`
display: flex;
align-items: flex-start;
justify-content: center;
flex-direction: column;
`;

const AsideLogo = Styled.figure`
margin-bottom: 2rem;
`;

const AsideList = Styled.ul`
color:${color.white};
list-style:none;
margin-bottom: 2rem;
`;

const AsideListIntro = Styled.h4`
text-transform: uppercase;
font-size: 1.5rem;
margin-bottom: 1rem;
color:${color.primaryAlt};
`;

const AsideListItemLink = Styled.a.attrs(({ href }) => ({
  href,
}))`
color: ${color.white};
margin-bottom: 1rem;
display: block;
text-decoration: none;
&:hover{color: ${color.secondaryAlt}};
&:active{text-decoration: underline};
`;

const AsideFooter = Styled.footer`
display: flex;
align-items: flex-start;
justify-content: flex-end;
flex-direction: column;
`;

const SideBar = ({ lists, links, button, account }) => {
  return (
    <Aside>
      <AsideHeader>
        {account && <AsideAccount>My Account</AsideAccount>}
        <AsideLogo>
          <img src={logo} alt="" />
        </AsideLogo>

        {lists.map((list) => (
          <AsideList>
            <AsideListIntro key={list.intro}>{list.intro}</AsideListIntro>
            {list.links.map((link) => (
              <AsideListItemLink key={link.path} href={link.path}>
                {link.label}
              </AsideListItemLink>
            ))}
          </AsideList>
        ))}

        {button && <Button type="white" text="Book a service" bordered />}
      </AsideHeader>

      {links && (
        <AsideFooter>
          {links.map((link) => (
            <AsideListItemLink href={link.path}>{link.label}</AsideListItemLink>
          ))}
        </AsideFooter>
      )}
    </Aside>
  );
};

export default SideBar;
